const prvaDiagnozaSepa = {
    ime: {
        name: 'ime',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Ime',
        },
    },
    priimek: {
        name: 'priimek',
        type: 'xs:string',
        formType: 'text-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Priimek',
        },
    },
    spol: {
        name: 'spol',
        type: 'tns:Spol',
        formType: 'gender-input',
        required: true,
        value: '',
        text: {
            sl: 'Spol',
        },
    },
    datumRojstva: {
        name: 'datumRojstva',
        type: 'xs:date',
        formType: 'date-input',
        required: true,
        value: undefined,
        text: {
            sl: 'Datum rojstva',
        },
        conf: { deltaMin: 18, deltaMax: null },
    },
    davcnaStevilka: {
        name: 'davcnaStevilka',
        type: 'xs:integer',
        formType: 'davcna-input',
        required: true,
        value: '',
        text: {
            sl: 'Davčna številka',
        },
    },
    transakcijskiRacun: {
        name: 'transakcijski-racun',
        type: 'quasi',
        formType: 'transkacijski-racun-input',
        required: true,
        value: {
            IBAN: undefined,
            nazivBanke: undefined,
            BIC: undefined,
        },
    },
    naslov: {
        name: 'naslov',
        type: 'tns:NaslovType',
        formType: 'address-input-group',
        required: true,
        value: {
            ulica: '',
            postnaStevilka: '',
            kraj: '',
        },
        text: {
            sl: 'Naslov prebivališča',
        },
        error: {
            ulica: null,
            postnaStevilka: null,
            kraj: null,
        }
    },
    podpisPlacnika: {
        name: 'podpisPlacnika',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis imetnika računa',
        },
    },
    datumPodpisa: {
        name: 'datumPodpisa',
        type: 'xs:dateTime',
        formType: 'auto-date-time-now',
        required: true,
        value: undefined,
    },
    podpisZavarovalec: {
        name: 'podpisZavarovalec',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis dolžnika',
        },
    },
    datumPodpisaDolznik: {
        name: 'datumPodpisa',
        type: 'xs:dateTime',
        formType: 'auto-date-time-now',
        required: true,
        value: undefined,
    },
}

module.exports = { prvaDiagnozaSepa };